//import { FormattedMessage } from 'react-intl';

import Language from 'assets/img/twemoji/1f1f1-1f1f7.svg'
import Cookie from 'assets/img/twemoji/1f36a.svg'
import Address from 'assets/img/twemoji/1f3e0.svg'
import BirthDate from 'assets/img/twemoji/1f382.svg'
import icons from 'assets/img/twemoji/1f38f.svg'
import CreditCard from 'assets/img/twemoji/1f4b3.svg'
import Device from 'assets/img/twemoji/1f4bb.svg'
import Email from 'assets/img/twemoji/2709.svg'
import Git from 'assets/img/twemoji/1f5c3.svg'
import Github from 'assets/img/twemoji/1f5c4.svg'
import Ip from 'assets/img/twemoji/1f4cd.svg'
import Issues from 'assets/img/twemoji/1f4a9.svg'
import Options from 'assets/img/twemoji/2699.svg'
import Password from 'assets/img/twemoji/1f511.svg'
import Project from 'assets/img/twemoji/2198.svg'
import neo4jd3 from 'assets/img/twemoji/2196.svg'
import User from 'assets/img/twemoji/1f600.svg'

    // Neo4j 라벨에 맞는 Font Awesome 아이콘을 사용하기 위한 이름 매칭
export const ICONS = {
    'Email': 'at',
    'Git': 'git',
    'Ip': 'map-marker',
    'Issues': 'exclamation-circle',
    'Language': 'language',
    'User': 'user',
    'zoomFit': 'arrows-alt',
    'zoomIn': 'search-plus',
    'zoomOut': 'search-minus',
    'Person': 'user',
    'Document': 'folder-open',
    'Organization': 'building',
    'Date': 'hourglass-start',
    'Location': 'globe',
    'Tag': 'tag',
    'Owner': 'user-plus',
}

// Neo4jD3에서 사용하는 이미지 정의
export const IMAGES = {
    'Address': Address,
    'BirthDate': BirthDate,
    'Cookie': Cookie,
    'CreditCard': CreditCard,
    'Device': Device,
    'Email': Email,
    'Git': Git,
    'Github': Github,
    'icons': icons,
    'Ip': Ip,
    'Issues': Issues,
    'Language': Language,
    'Options': Options,
    'Password': Password,
    'Project': Project,
    'Project|name|neo4jd3': neo4jd3,
    'User': User
};

export const CLASS_COLORS = {
    'Document': '#405f9e',
    'Person': '#6dce9e',
    'Organization': '#a5abb6',
    'Date': '#f2baf6',
    'Tag': '#ffab1a',
    'Owner': '#70edee'
};

export const RELATIONSHIP_TEXT = {
    'OW': '소유자',
    'OG': '조직',
    'DT': '시간',
    'PS': '조직원',
    'LT': '위치'
};

export const HIGHLIGHT = {
    'documentCond': { 
        class: 'Document',
        property: 'fileName',
    },
    'ownerCond': { 
        class: 'Owner',
        property: 'name',
    },
    'tagCond': { 
        class: 'Tag',
        property: 'name',
    },
    'personCond': { 
        class: 'Person',
        property: 'name',
    },
    'organizationCond': { 
        class: 'Organization',
        property: 'name',
    },
    'locationCond': { 
        class: 'LocationCond',
        property: 'name',
    },
};